export default class Tabs {
	constructor() {
		this.triggers = document.querySelectorAll('.tab-trigger');
		this.tabs = document.querySelectorAll('div[data-tab]');
		this.next = document.querySelector("a[data-dir='tab-next']");
		this.prev = document.querySelector("a[data-dir='tab-prev']");
		this.bar = document.querySelector('.tabs .progress');

		this.listeners();
		Tabs.progress(this.triggers[0]);
	}

	listeners() {
		[...this.triggers].forEach((el) => {
			el.addEventListener('click', this.switchTab, false);
		});

		this.next && this.next.addEventListener('click', this.switchTab, false);
		this.prev && this.prev.addEventListener('click', this.switchTab, false);
	}

	switchTab(el) {
		el.preventDefault();

		Tabs.removeActive();
		Tabs.setActive(el);

		Tabs.updatePrev();
		Tabs.updateNext();
	}

	static progress(trigger) {
		const triggers = document.querySelectorAll('.tab-trigger');
		const sections = triggers.length + 1;
		const index = Tabs.index(trigger, triggers) + 1;
		const progBar = document.querySelector('.progress');

		if (progBar) {
			progBar.style.width = `calc( (100% * ${index}) / ${sections} )`;
		}
	}

	static index(item, collection) {
		return [].slice.call(collection).indexOf(item);
	}

	static setActive(el) {
		const tabId = el.currentTarget.dataset.tab;
		const trigger = document.querySelector(`.tab-trigger[data-tab=${tabId}]`);
		const tab = document.querySelector(`.tab[data-tab=${tabId}]`);

		trigger.dataset.active = true;
		tab.dataset.active = true;

		Tabs.progress(trigger);
	}

	static getActive() {
		return document.querySelector('.tabs-head [data-active]');
	}

	static updateNext() {
		const nextTrigger = document.querySelector("a[data-dir='tab-next']");
		const nextTarget = Tabs.getActive().nextElementSibling;

		if (nextTarget.classList.contains('tab-nav')) {
			nextTrigger.classList.add('disable');
		} else {
			nextTrigger.classList.remove('disable');
			nextTrigger.dataset.tab = nextTarget.dataset.tab;
		}
	}

	static updatePrev() {
		const prevTrigger = document.querySelector("a[data-dir='tab-prev']");
		const prevTarget = Tabs.getActive().previousElementSibling;

		if (prevTarget.classList.contains('tab-nav')) {
			prevTrigger.classList.add('disable');
		} else {
			prevTrigger.classList.remove('disable');
			prevTrigger.dataset.tab = prevTarget.dataset.tab;
		}
	}

	static removeActive() {
		[...document.querySelectorAll('.tabs [data-active]')].forEach(
			(el) => delete el.dataset.active
		);
	}
}
